import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@simOn/utils/tokens';
import { Observable } from 'rxjs';
import {
  AgentConversationDto,
  AgentConversationListEntryDto,
  AgentMessageDto,
  AgentUserStatusDto,
  CreateAgentConversationDto,
  SendAgentMessageDto
} from '../model';

/** Thin HTTP client of `/api/Agents/*`. Orchestration lives in `AgentService`, state in `AgentChatStore`. */
@Injectable({ providedIn: 'root' })
export class AgentApiService {
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = inject(API_URL);

  createConversation(dto: CreateAgentConversationDto = {}): Observable<AgentConversationDto> {
    return this._http.post<AgentConversationDto>(`${this._apiUrl}/Agents/CreateConversation`, dto);
  }

  getConversations(): Observable<AgentConversationListEntryDto[]> {
    return this._http.get<AgentConversationListEntryDto[]>(`${this._apiUrl}/Agents/GetConversations`);
  }

  getConversation(conversationId: string): Observable<AgentConversationDto> {
    const params = new HttpParams().append('conversationId', conversationId);
    return this._http.get<AgentConversationDto>(`${this._apiUrl}/Agents/GetConversation`, { params });
  }

  sendMessage(dto: SendAgentMessageDto): Observable<AgentMessageDto> {
    return this._http.post<AgentMessageDto>(`${this._apiUrl}/Agents/SendMessage`, dto);
  }

  getUserStatus(): Observable<AgentUserStatusDto> {
    return this._http.get<AgentUserStatusDto>(`${this._apiUrl}/Agents/GetUserStatus`);
  }
}
